"use client";

import React from "react";

const Comparison = () => {
  return (
    <section id="comparison" className="py-16 bg-white text-black">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center mb-12">Comparison</h2>
        <div className="overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="p-4 text-lg font-semibold">Feature</th>
                <th className="p-4 text-lg font-semibold text-center">Seozast</th>
                <th className="p-4 text-lg font-semibold text-center">Surfer SEO</th>
                <th className="p-4 text-lg font-semibold text-center">Jasper</th>
                <th className="p-4 text-lg font-semibold text-center">Frase</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-gray-200">
                <td className="p-4">Price</td>
                <td className="p-4 text-center text-emerald-600 font-bold">$19.99/mo</td>
                <td className="p-4 text-center">$79/mo</td>
                <td className="p-4 text-center">$69/mo</td>
                <td className="p-4 text-center">$45/mo</td>
              </tr>
              <tr className="border-b border-gray-200">
                <td className="p-4">AI Search Optimization</td>
                <td className="p-4 text-center">✓</td>
                <td className="p-4 text-center">✓</td>
                <td className="p-4 text-center">✗</td>
                <td className="p-4 text-center">✓</td>
              </tr>
              <tr className="border-b border-gray-200">
                <td className="p-4">Real-Time Analytics</td>
                <td className="p-4 text-center">✓</td>
                <td className="p-4 text-center">✗</td>
                <td className="p-4 text-center">✗</td>
                <td className="p-4 text-center">✗</td>
              </tr>
              <tr className="border-b border-gray-200">
                <td className="p-4">GitHub Publishing</td>
                <td className="p-4 text-center">✓</td>
                <td className="p-4 text-center">✗</td>
                <td className="p-4 text-center">✗</td>
                <td className="p-4 text-center">✗</td>
              </tr>
              <tr className="border-b border-gray-200">
                <td className="p-4">Developer Format Exports</td>
                <td className="p-4 text-center">✓</td>
                <td className="p-4 text-center">✗</td>
                <td className="p-4 text-center">✗</td>
                <td className="p-4 text-center">✗</td>
              </tr>
              <tr className="border-b border-gray-200">
                <td className="p-4">Internal Linking Automation</td>
                <td className="p-4 text-center">✓</td>
                <td className="p-4 text-center">✗</td>
                <td className="p-4 text-center">✗</td>
                <td className="p-4 text-center">✓</td>
              </tr>
              <tr className="border-b border-gray-200">
                <td className="p-4">No Credit Card</td>
                <td className="p-4 text-center">✓</td>
                <td className="p-4 text-center">✗</td>
                <td className="p-4 text-center">✗</td>
                <td className="p-4 text-center">✓</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="mt-8 text-center">
          <a
            href="/register"
            className="inline-block bg-emerald-600 text-white font-semibold py-3 px-6 rounded-lg hover:bg-emerald-700 transition duration-300"
          >
            Try Seozast Free
          </a>
        </div>
      </div>
    </section>
  );
};

export default Comparison;